export const extractV2KeyInfo = v2Key => {
  if (v2Key) {
    const v2Keys = v2Key.split('&&!!');
    if (v2Keys.length > 0) {
      return { businessIds: v2Keys[0], tabIndex: v2Keys[1] };
    }
  }
  return {};
};

export const productAgreementUrl = v2Info => {
  const productAgreementURL = process.env.REACT_APP_CONTRACT_MANAGER_V2_URL;
  return `${productAgreementURL}/productAgreements/${v2Info.businessIds}/${v2Info.tabIndex}`;
};
